import type { SysUserInfo } from './types/sysAuth';

const TOKEN_KEY = 'sys_admin_token';
const REFRESH_KEY = 'sys_admin_refresh_token';
const USER_KEY = 'sys_admin_user';

export function getSysToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setSysTokens(token: string, refreshToken: string): void {
  
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
}

export function clearSysTokens(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  clearSysUser();
}

export function getSysUser(): SysUserInfo | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SysUserInfo;
  } catch {
    return null;
  }
}

export function setSysUser(user: SysUserInfo): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSysUser(): void {
  localStorage.removeItem(USER_KEY);
}

export function getSysRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}
